import { Navigate, Route, RouterProvider } from 'react-router-dom';
import Outline from '#@planner/planner/planner.jsx';
import { DEFAULT_AUTH_ROUTES as AUTH_ROUTES, AuthProvider, getAuthHeader } from '#lib/hooks/use-auth.jsx';
import { STATES as AUTH_STATES } from '#lib/components/authenticator.jsx';
import Auth from '#routes/auth.jsx';
import Home from '#routes/manage/home/home.jsx';
import AppShell from '#routes/app-shell.jsx';
import { makeCrudRoutes } from 'lib/helpers/routes.jsx';
import ThemeSearch from '#routes/manage/theme/search.jsx';
import ThemeEdit from '#routes/manage/theme/edit.jsx';
import ItineraryEdit from '#routes/manage/itinerary/edit.jsx';
import Connections from '#routes/manage/connections/connections.jsx';
import Profiles from '#routes/manage/profiles/profiles.jsx';
import Users from '#routes/manage/users/users.jsx';
import { Private as _Private } from 'lib/components/require-auth.jsx';
import SettingsRoot from '#routes/settings/settings-root.jsx';
import Account from '#routes/settings/account.jsx';
import Password from '#routes/settings/password.jsx';
import PaymentLandingPage from '#routes/settings/payment-landing-page.jsx';
import Orders from '#routes/manage/connections/orders.jsx';
import { CrudRoute as _CrudRoute } from 'src/@crud';
import { jsonHeaders } from '#lib/helpers/fetch.js';
import { createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import Portal from '#lib/components/portal.jsx';
import Toaster from '#lib/components/toaster.jsx';
import Templates from './manage/templates/templates.jsx';
import Documentation from '../documentation/documentation.jsx';
import IntlEditor from './manage/intl/intlEditor.jsx';
import AdminPanel from './manage/admin/adminPanel.jsx';
import Billing from './settings/billing/index.jsx';
import ItinerarySearch from './manage/itinerary/search/search.jsx';
import ThemeTextsEditor from './manage/themetexts/editor.jsx';

const routeToAuthenticatorState = {
    [AUTH_STATES.SIGN_IN]: AUTH_ROUTES.SIGN_IN,
    [AUTH_STATES.SIGN_UP]: AUTH_ROUTES.SIGN_UP,
    [AUTH_STATES.COMPLETE_NEW_PASSWORD]: AUTH_ROUTES.COMPLETE_NEW_PASSWORD,
    [AUTH_STATES.FORGOT_PASSWORD]: AUTH_ROUTES.FORGOT_PASSWORD,
    [AUTH_STATES.CREATE_NEW_PASSWORD]: AUTH_ROUTES.CREATE_NEW_PASSWORD,
    [AUTH_STATES.VERIFY_EMAIL]: AUTH_ROUTES.VERIFY_EMAIL,
    [AUTH_STATES.CONFIRM_SIGNUP]: AUTH_ROUTES.CONFIRM_SIGNUP
};

function checkRouteAuth(user, meta, location) {
    //TODO: controllare i ruoli qui
    return null;

    // const userRoles = meta.data?.roles;
    // if (!userRoles) return null;
    //
    // //retrieve routeAuthModel elements from userRoles
    // const routeAuthRoles = userRoles
    //     ?.map((role) => routesByRole[role])
    //     .filter((el) => el) //remove roles without route model
    //     .sort((a, b) => a.order - b.order);
    //
    // const pathname = location.pathname;
    // let excludeRedirect;
    //
    // for (let role of routeAuthRoles)
    //     for (let route of role.routes)
    //         if (matchPath(route, pathname)) {
    //             if (route.exclude) {
    //                 excludeRedirect = parseRedirectUrl(
    //                     pathname,
    //                     route.redirect ?? role.redirect
    //                 );
    //                 break; //if another role grants the access for the excluded path => ignore exclude
    //             }
    //             return null;
    //         }
    //
    // return (
    //     excludeRedirect ??
    //     parseRedirectUrl(pathname, routeAuthRoles.find(() => true)?.redirect)
    // );
}

async function getUserInfo() {
    const authHeaders = await getAuthHeader();
    const headers = {
        ...jsonHeaders,
        ...authHeaders
    };

    const response = await fetch(`${API_URL}/p/user/auth-info`, {
        headers
    });

    const data = await response.json();
    const roles = data?.roles || [];
    return { ...data, roles };
}

export const Private = (Element) => _Private(Element, checkRouteAuth);

export default function getAppRoutes() {
    return (
        <Route
            path="*"
            element={
                <AuthProvider options={{ getMeta: getUserInfo }}>
                    <AppShell />
                    <Portal>
                        <Toaster />
                    </Portal>
                </AuthProvider>
            }
        >
            <Route index element={<Navigate to={'home'} state={{ from: '/' }} />} />
            {Object.entries(routeToAuthenticatorState).map(([state, path]) => (
                <Route key={state} path={path} element={<Auth state={state} />} />
            ))}
            <Route path="outline" element={<Outline />} />
            <Route
                path="home"
                element={Private(
                    <_CrudRoute name="home">
                        <Home />
                    </_CrudRoute>
                )}
            />
            <Route path="documentation" element={<Documentation />} />
            <Route path="settings" element={<SettingsRoot />}>
                <Route index element={<Navigate to="account" />} />
                <Route path="account" element={<Account />} />
                <Route path="billing" element={<Billing />} />
                <Route path="password" element={<Password />} />
                <Route path="payment" element={<PaymentLandingPage />} />
            </Route>
            <Route path="manage">
                {makeCrudRoutes('itinerary', ItinerarySearch, ItineraryEdit)}
                {makeCrudRoutes('theme', ThemeSearch, ThemeEdit)}
                <Route path="profiles" element={Private(<Profiles />)} />
                <Route path="users" element={Private(<Users />)} />
                <Route
                    path="templates"
                    element={Private(
                        <_CrudRoute name="templates">
                            <Templates />
                        </_CrudRoute>
                    )}
                />
                <Route path="connections" element={Private(<Connections />)} />
                <Route path="orders/:id" element={Private(<Orders />)} />
                <Route path="intl" element={Private(<IntlEditor />)} />
                <Route path="themetexts" element={Private(<ThemeTextsEditor />)} />
                <Route path="admin" element={Private(<AdminPanel />)} />
            </Route>
        </Route>
    );
}

export function AppRouter(props) {
    const { children, ...rest } = props;
    const router = createBrowserRouter(createRoutesFromElements(getAppRoutes()));
    return (
        <RouterProvider router={router} {...rest}>
            {children}
        </RouterProvider>
    );
}
